import React from 'react';

export type CollectionContextType =
  | {
      id: string;
      record: Record<string, unknown>;
      collectionId: string;
      index: number;
    }
  | Record<string, never>;

export const CollectionContext = React.createContext<CollectionContextType>({});
